export const AMOUNT_MIN_TO_USE_CREDIT = 63
export const CREDIT_CLARO_PAY = "credit-claro-pay"
export const ADVANCEMENT_CLARO_PAY = "advancement-claro-pay"
export const servicesIdTAE = [147,143,148,149, 146];
export const AMIGO_PAGUITOS = 247
export const MICROAPP = "MicroApp"
export const MINIAPP = "MiniApp"
export const TELMEX = 116
export const TELCEL_IDS = [143,113,146];
export const OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE = 3
export const OFFER_TELCEL_PAQUETE_INTERNET_AMIGO = 2
export const OFFER_TELCEL_PAQUETE_POR_TIEMPO = 4
export const OFFER_TELCEL_RECARGA = 0
export const OFFER_TELCEL_POSPAGO = 1
export const OFFER_TELCEL_AMIGO_PAGUITOS = 5
export const OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL = 6
export const OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN = 7
export const REDIRECT = 1
export const OPEN_NEW_MICROAPP = 2
export const CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE = 4
export const CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO = 8
export const CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO = 3
export const CATEGORY_PLANS_ID_RECARGA = 5
export const CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS = 31
export const CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO = 34
export const SERVICE_ID_TELCEL_RECARGA = 143
export const SERVICE_ID_TELCEL_POSPAGO = 113
export const SERVICE_ID_TELCEL_PAQUETES_POSPAGO = 254
export const SERVICE_ID_TELCEL_PLANES = 146
export const ARCUS_BILLER_IDS = [83,86,60,112,125,70,88,94]
export const BUNDLE_ID_CONTAINER_TELCEL = ["com.telcel.contenedor","com.telcel.contenedor.uat"]
export const AMOUNT_MAX_TO_USE_ADVANCEMENT = 100;
export const ACTION_COOKIE_SAVE = "saveck"
export const SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS = {
    bank: "Banco Inbursa",
    periodicity: "Mensual",
    product: "Factura Telcel",
    providerService: "Radiomóvil Dipsa SA de CV"
}
export const MAX_AMOUNT_SERVICE_PAYMENT=23360
export const URL_APPLE_STORE = "https://apps.apple.com/mx/app/claro-pay/id1502765283"
export const URL_PLAY_STORE = "https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay"
export const ADVANCEMENT_CARD_INFO = {
    value: ADVANCEMENT_CLARO_PAY,
    mark : "996",
    type :  0,
    lastDigits : " ",
    update: false
}
export const TELCEL_POSPAGO_MICROAPP_ID = "TelcelPospagoPS"